/** URL search-param helpers: every list keeps filters, cursor row and playhead in the URL. */

export function str(v: unknown): string | undefined {
  return typeof v === 'string' && v.length > 0 ? v : typeof v === 'number' ? String(v) : undefined
}

export function num(v: unknown): number | undefined {
  const n = typeof v === 'number' ? v : typeof v === 'string' ? Number(v) : NaN
  return Number.isFinite(n) ? n : undefined
}

export function oneOf<T extends string>(v: unknown, allowed: readonly T[]): T | undefined {
  return typeof v === 'string' && (allowed as readonly string[]).includes(v) ? (v as T) : undefined
}

/** Drops empty values so URLs stay short and canonical. */
export function clean<T extends Record<string, unknown>>(o: T): T {
  return Object.fromEntries(Object.entries(o).filter(([, v]) => v !== undefined && v !== null && v !== '')) as T
}
